import AbstractComponent from './AbstractComponent.js';

class SearchComponent extends AbstractComponent {
    constructor(container, props) {
        super(container, props);
        this.state = {
            searchData: props.searchData,
            suggestions: [],
        };
        this.renderMethod = 'appendTemplate';
        this.render();
    }

    setKeyWord(word) {
        this.state.searchData.placeName = word;
        this.searchKey.value = word;
        this.suggestion_list.innerHTML = '';
    }

    setSuggestions(suggestions = []) {
        // Array expected
        this.state.suggestions = suggestions;
        this.showSuggestions();
    }

    setSearchBy(val) {
        this.state.searchData.by = val;
        this.searchBy.value = val;
    }

    setPlaceId(val) {
        this.state.searchData.place_id = val;
    }

    // =============================================================
    // The function returns a maximum of 10 matching words
    // to display for the user as suggestions
    // =============================================================
    getMatchingWords() {
        // If suggestions are empty, get suggestions from API
        let matchWords = [];
        if (!this.state.suggestions || !this.state.suggestions.length) {
            matchWords = this.props.getTenMatchingWords(this.searchKey.value);
        } else {
            matchWords = this.state.suggestions.filter(suggestion => suggestion.search_phrase.toLowerCase().match(this.searchKey.value.toLowerCase()));
        }
        
        // If match words is still empty even after searching
        if (this.state.suggestions && this.state.suggestions.length < 2) {          
            matchWords = this.props.getTenMatchingWords(this.searchKey.value);
        } else return matchWords;

        // Return last attempt of API match
        return matchWords;
    }

    // =============================================================
    // The function displays a list of suggestions to based on
    // the matching words provided
    // =============================================================
    showSuggestions() {
        this.suggestion_list.innerHTML = '';

        this.state.suggestions.forEach(suggestion => {
            const sugg_item = `<li class="sugg-word list-group-item py-1"
                data-place-id="${suggestion.place_id}"
                data-keyword="${suggestion.search_phrase}"
                data-type="${suggestion.type}"
                >
                    <span>${suggestion.search_phrase}</span>
                </li>`;
            this.suggestion_list.innerHTML += sugg_item;
        });
        const sugg_words = document.getElementsByClassName('sugg-word');

        for (let i = 0; i < sugg_words.length; i++) {
            // Add click events to all suggested words
            sugg_words[i].addEventListener('click', () => {
                this.setSearchBy(sugg_words[i].getAttribute('data-type'));
                this.setPlaceId(Number(sugg_words[i].getAttribute('data-place-id')));
                this.setKeyWord(sugg_words[i].getAttribute('data-keyword'));
            });
        }
    }
    
    addFunctionality() {
        this.searchBy = document.getElementById('searchBy');
        this.searchKey = document.getElementById('searchKey');
        this.searchBtn = document.getElementById('searchBtn');
        this.suggestion_list = document.getElementById('sugg-list');

        this.searchKey.addEventListener('input', () => {
            // Only match if input has at least 2 letters
            if (this.searchKey.value.length > 1) {
                this.setSuggestions(this.getMatchingWords());
            }
        });

        this.searchBtn.addEventListener('click', (e) => {
            e.preventDefault();
            // When the search button is pressed, the placeName and searchBy
            // in the main stete must be 
            // If searchBy is not provided, default to  ALL
            this.state.searchData.placeName = this.searchKey.value || '';
            this.state.searchData.by = this.searchBy.value || 'All';
            this.props.handleSearch(this.searchKey.value, this.searchBy.valu);
        });
    }

    render() {
        this.template = `
            <form class="form-inline my-2 my-lg-0" autocomplete="off">
                <div class="input-group mx-1">
                    <input id="searchKey" class="form-control position-relative" type="search" placeholder="eg. Soshanguve..." list="suggestions">
                    <ul id="sugg-list" class="position-absolute list-group mt-5" style="z-index: 1;"></ul>
                    <select id="searchBy" class="custom-select position-relative">
                        <option selected disabled value="">Search By</option>
                        <option value="All">All</option>
                        <option value="wellknown_name">Wellknown Name</option>
                        <option value="block">Block/Zone</option>
                        <option value="township">Township</option>
                        <option value="city">City</option>
                        <option value="province">Province</option>
                    </select>
                </div>
                <button id="searchBtn" class="btn btn-outline-success my-2 my-sm-0" type="submit">Search</button>
            </form>
        `;
        super.render();
        this.addFunctionality();
    }
}

export default SearchComponent;